// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"75c0d55f","453":"54292a4b","732":"35ed01f5","977":"29f78a79"}[chunkId] + ".chunk.js";
};